
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"10","height":"17","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.043 1.66L1.5 8.86l7.543 7.2","stroke":"#4F4F4F","stroke-width":"1.92","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}})])
      }
    
      }
    